<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="card-plain">
            <template slot="header">
              <h4 class="card-title">Welcome Back {{ user && user.name || '...' }}</h4>
              <p class="card-category">Below are your Campaigns</p>
            </template>
            <div v-if="tableData && tableData.length" class="table-responsive">
              <c-table class="table-hover" :columns="tableColumns" :data="tableData"></c-table>
            </div>
            <p v-else-if="loading" class="card-category">Loading Campaigns...</p>
            <p v-else class="card-category">No Campaigns found...</p>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

  import CTable from 'src/components/CampaignsTable.vue'
  import Card from 'src/components/Cards/Card.vue'
  const tableColumns = ['Name', 'Start Time', 'End Time', 'Drivers']
  export default {
    components: {
      CTable,
      Card
    },
    data () {
      return {
        tableColumns: [...tableColumns],
        tableData: [],
        user: '',
        loading: false,
      }
    },
    async created () {
      try {
        this.loading = true
        const app = getApp()
        const functions = getFunctions(app, 'europe-west1')
        // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
        await this.getUser(functions)
        await this.getCampaigns(functions)
      } catch (error) {
        alert('Error querying API. Error: ' + error)
      } finally {
        this.loading = false
      }
    },
    methods: {
      async getUser(functions) {
        try {
          const getUser = httpsCallable(functions, 'getUser');
          const getUserRes = await getUser()
          this.user = getUserRes.data.data
        } catch (error) {
          alert('Error getting User. Error: ' + error)
        }
      },
      async getCampaigns(functions) {
        try {
          const getCampaigns = httpsCallable(functions, 'getCampaigns');
          const getCampaignsRes = await getCampaigns()
          this.tableData = getCampaignsRes.data.data
        } catch (error) {
          alert('Error getting Campaigns. Error: ' + error)
        }
      },
    }
  }
</script>
<style>
</style>
